import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import { HlswType } from "./HlswTable";
import api from "../../../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import VieJsonDialog from "../../VieJsonDialog";


interface hlswDetailProps {
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  rowDetail: HlswType | null;
  setRowDetail: React.Dispatch<React.SetStateAction<HlswType>>;
  getHlswList: any;
  p_order:any;
  p_prc_yn:any;
  p_use_check:any;
  p_worker:any;
  p_prc_s_date:string;
  p_prc_e_date:string;
}

const initailData: HlswType = {
  idx: -1,
  id: "",
  worker: "",
  work_date: "",
  work_yn: "",
  use_check: "",

  prc_worker: "",
  prc_date: "",
  prc_yn: "",

  isp_worker: "",
  isp_date: "",
  isp_yn: "",

  category: "",
  answer: "",

  translate_need:"",

  activity_vi: "",
  question_a_vi: "",
  question_b_vi: "",
  question_vi: "",
  choice_vi_1: "",
  choice_vi_2: "",
  choice_vi_3: "",
  choice_vi_4: "",

  activity_en: "",
  question_a_en: "",
  question_b_en: "",
  question_en: "",
  choice_en_1: "",
  choice_en_2: "",
  choice_en_3: "",
  choice_en_4: "",

  activity_ko: "",
  question_a_ko: "",
  question_b_ko: "",
  question_ko: "",
  choice_ko_1: "",
  choice_ko_2: "",
  choice_ko_3: "",
  choice_ko_4: "",
};


const HlswDetailDialog = (props: hlswDetailProps) => {
  // console.log("props", props);

  const [data, setData] = useState<HlswType>(initailData);

  const [openJsonDialog, setOpenJsonDialog] = useState<boolean>(false)

  const [auths, setAuths] = useState([]);
  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  

  // stt 수정 함수

  const getAuths = async () => {
    var result = await api.get("/getAuths");

    setAuths(result.data.data);
    // console.log('result.data.data',result.data.data)
  };


  const saveHlswData = async () => {

    const formData = new FormData();

    if(data.category == "None"){
      alert('Category 를 선택하세요.')
      return;
    }

    formData.append("email", email);

    formData.append("datas", JSON.stringify(data));

    console.log('수정할 데이터', JSON.stringify(data))

    // formData.append("nvConScript", JSON.stringify(con_script));

    await api.post("/vie-02-hlswUpdate",formData)
    .then((res:any) => { alert("업데이트가 완료되었습니다."); props.setDialogOpen(false); props.getHlswList(props.p_order,props.p_prc_yn,props.p_use_check,props.p_worker,props.p_prc_s_date,props.p_prc_e_date); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }

  const openGuideWindow = () => {
    const imageUrl = `${process.env.PUBLIC_URL}/img/vie-task/Vie-HellaSwag.jpg`;

    window.open(imageUrl, '_blank');
  }

  useEffect(() => {
    getAuths();
    setData(initailData);
    // console.log("sampleDetailDialog");
    if (props.rowDetail != null){
      setData(props.rowDetail);
      // if(props.rowDetail.state)
      console.log('로우 디테일',props.rowDetail)
    }
    
  }, [props.rowDetail]);

  return (
    <Box>
      <Dialog maxWidth="xl" open={true} fullWidth={true}>
        <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
          <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>Task-02. HLSW 데이터 확인</Box>
          <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
        </DialogTitle>
        <DialogContent dividers>
          <Box>
            <Box sx={{position: "sticky",top: "-16px", zIndex: 1, backgroundColor:"#fff"}} >
  
              {/* <Box display="flex" justifyContent="center"> */}
              <Box display="flex">

                <Box display="flex" sx={{marginLeft: "50px"}}>
                  <Box sx={{width:"100%"}}>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>idx</Box>
                      <Box sx={{fontSize:"14px", width:"130px"}}>{data.idx}</Box>
                      {/* <TextField
                        id="idx"
                        value={data.idx}
                        variant="standard"
                        sx={{width:"100%", height:"20px", marginLeft:"8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                        InputProps={{
                          readOnly: true,
                          style: {width: "320px", height:"20px", fontSize:"14px"},
                        }}
                      /> */}
                    </Box>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>id</Box>
                      <Box sx={{fontSize:"14px", width:"130px"}}>{data.id}</Box>
                      {/* <TextField
                        id="id"
                        value={data.id}
                        variant="standard"
                        sx={{width:"100%", height:"20px", marginLeft:"8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                        InputProps={{
                          readOnly: true,
                          style: {width: "320px", height:"20px", fontSize:"14px"},
                        }}
                      /> */}
                    </Box>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>작업워커</Box>
                      <Box sx={{fontSize:"14px", width:"190px"}}>{data.worker}</Box>

                      <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>작업상태</Box>
                      <Box sx={{fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                          backgroundColor: (data.work_yn === "Y" ? "#27cc2f" : "#bbb"), color:"#fff"
                      }}>
                        {(data.work_yn === "Y" ? "작업완료" : "미작업")}
                      </Box>

                      <Box sx={{fontSize:"14px",fontWeight:700, width:"120px", marginLeft:"32px"}}>번역검토필요</Box>
                      <Box sx={{fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                          backgroundColor: (data.translate_need === "Y" ? "#9c27b0" : (data.translate_need === "None" ? "#bbb" : "#27cc2f")), color:"#fff"
                      }}>
                        {(data.translate_need === "Y" ? "검토필요" : (data.translate_need === "None" ? "미작업" : "검토완료"))}
                      </Box>
                      {/* <TextField
                        id="worker"
                        value={""}
                        variant="standard"
                        sx={{height:"20px", marginRight:"32px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                        InputProps={{
                          readOnly: true,
                          style: {width: "160px", height:"20px", fontSize:"14px"},
                        }}
                      /> */}
                    </Box>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>업로드시간</Box>
                      <Box sx={{fontSize:"14px", width:"190px"}}>{data.work_date}</Box>
                      {/* <TextField
                        id="work_date"
                        value={""}
                        variant="standard"
                        sx={{height:"20px", marginRight:"32px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                        InputProps={{
                          readOnly: true,
                          style: {width: "160px", height:"20px", fontSize:"14px"},
                        }}
                      /> */}
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>체크결과</Box>
                      <Select id="use_check" value={data.use_check} onChange={(e) => {setData({ ...data, use_check: e.target.value });}} sx={{color:"green",width:"180px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={"T"}>T - 사용가능</MenuItem>
                        <MenuItem dense value={"C"}>C - 내용수정</MenuItem>
                        <MenuItem dense value={"F"}>F - 사용불가</MenuItem>
                      </Select>
                    </Box>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"96px"}}>Category</Box>
                      <Select id="category" value={data.category} onChange={(e) => {setData({ ...data, category: e.target.value });}} sx={{color:"green",width:"180px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={"사회/정치/산업"}>사회/정치/산업</MenuItem>
                        <MenuItem dense value={"건강/의학"}>건강/의학</MenuItem>
                        <MenuItem dense value={"날씨/자연/동식물"}>날씨/자연/동식물</MenuItem>
                        <MenuItem dense value={"음식/일상생활"}>음식/일상생활</MenuItem>
                        <MenuItem dense value={"IT/과학"}>IT/과학</MenuItem>
                        <MenuItem dense value={"역사/문화/예술/공예/의상"}>역사/문화/예술/공예/의상</MenuItem>
                        <MenuItem dense value={"일반상식/기타"}>일반상식/기타</MenuItem>
                      </Select>
                      <Button variant="contained" size="small" color="secondary" sx={{fontWeight:700, margin:"8px 16px 8px 200px"}} onClick={() => openGuideWindow()}>
                        OPEN GUIDE
                      </Button>
                      <Button variant="contained" size="small" sx={{fontWeight:700, margin:"8px 16px 8px 200px", backgroundColor:"#e79055"}} onClick={() => setOpenJsonDialog(true)}>
                        OPEN JSON
                      </Button>
                      {openJsonDialog ? <VieJsonDialog task={"02"} idx={data.idx} setOpenJsonDialog={setOpenJsonDialog} />:<></>}
                    </Box>
                    {/* <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>화자1</Box>
                      {speaker1 && 
                      <Box display="flex" sx={{alignItems:"center"}}>
                        <Box sx={{fontSize:"14px",fontWeight:700}}>ID</Box>
                        <Box sx={{fontSize:"14px", marginLeft:"8px",marginRight:"12px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                          {speaker1.id}
                        </Box>
                        <Box sx={{fontSize:"14px",fontWeight:700}}>성별</Box>
                        <Box sx={{fontSize:"14px", marginLeft:"8px",marginRight:"12px", border:"1px solid #fff", padding: "2px 6px 2px 6px", borderRadius:"4px",
                                color:"#fff", backgroundColor:(speaker1.gender === "남성" ? "#498ad5" : "#d549a6")}}>
                          {speaker1.gender}
                        </Box>
                        <Box sx={{fontSize:"14px",fontWeight:700}}>나이대</Box>
                        <Box sx={{fontSize:"14px", marginLeft:"8px",marginRight:"12px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                          {speaker1.agegroup}
                        </Box>
                      </Box>
                      } 
                    </Box>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>화자2</Box>
                      {speaker2 && 
                      <Box display="flex" sx={{alignItems:"center"}}>
                        <Box sx={{fontSize:"14px",fontWeight:700}}>ID</Box>
                        <Box sx={{fontSize:"14px", marginLeft:"8px",marginRight:"12px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                          {speaker2.id}
                        </Box>
                        <Box sx={{fontSize:"14px",fontWeight:700}}>성별</Box>
                        <Box sx={{fontSize:"14px", marginLeft:"8px",marginRight:"12px", border:"1px solid #fff", padding: "2px 6px 2px 6px", borderRadius:"4px",
                                color:"#fff", backgroundColor:(speaker2.gender === "남성" ? "#498ad5" : "#d549a6")}}>
                          {speaker2.gender}
                        </Box>
                        <Box sx={{fontSize:"14px",fontWeight:700}}>나이대</Box>
                        <Box sx={{fontSize:"14px", marginLeft:"8px",marginRight:"12px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                          {speaker2.agegroup}
                        </Box>
                      </Box>
                      }
                    </Box> */}
                    
                    {/* <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      {((data.reject_rsn !== "" && data.reject_rsn !== "None")) ? <Box>부적합사유: <b style={{color:"red"}}>{data.reject_rsn}</b></Box> : ""}
                    </Box> */}
                    
                  </Box>
                </Box>
            
              {/* </form> */}
              </Box>

              {/* <Box sx={{border: "3px solid #3e36a5", margin: "auto", width:"1470px"}}>
                {kiDoc.length > 0 &&
                  kiDoc.map((doc:KiDoc) =>

                  <Box key={doc.did}>
                    <Box sx={{display:"flex", justifyContent:"center", fontSize:"14px", height:"6px"}}>
                      <Box sx={{margin:"1px",marginRight:"24px"}}>문서ID : <b style={{color:"#498ad5"}}>{doc.did}</b></Box>
                      <Box sx={{margin:"1px",marginRight:"24px"}}>지식주제분류 : <b style={{color:"#498ad5"}}>{doc.gub_kinm} {doc.gub_subnm != "" ? <b> 세분류 : + {doc.gub_subnm}</b> : "" } </b></Box>
                      <Box sx={{margin:"1px"}}>사용여부 : {doc.use_yn}</Box>
                    </Box>
                    <Box display="flex" sx={{alignItems:"center", marginLeft:"4px"}}>
                      <Box sx={{height:"12px",fontSize:"14px",color:"#fff",marginRight:"12px",backgroundColor:"#498ad5",padding:"2px",borderRadius:"5px"}}>문장ID</Box>
                      <Box sx={{height:"12px",fontSize:"14px",color:"#fff",backgroundColor:"#498ad5",padding:"2px",borderRadius:"5px"}}>문장텍스트</Box>
                    </Box>
                    <Box sx={{margin:"2px", height:"88px", overflow:"auto"}}>
                    {doc.ki_stc.length > 0 && doc.ki_stc.map((stc:KiStc) =>
                      <Box key={stc.sid} display="flex" sx={{alignItems:"center",border:"2px solid #498ad5"}}>
                        <Box sx={{width:"44px",fontWeight:600,fontSize:"20px", marginRight:"6px", textAlign:"center"}}>{stc.sid}</Box>
                        <textarea defaultValue={stc.stext} style={{width:"1390px", height:"20px", fontSize:"11px", padding:"2px"}} />
                      </Box>
                    )}
                    </Box>

                  </Box>
                  )}
              </Box> */}
              <Box display="flex" justifyContent="center" sx={{textAlign:"center", marginTop:"2px", background: "linear-gradient(to right, #e6e6e6 30%, #deebfa 70%)"}}>
                {/* <Box sx={{fontSize:"14px", fontWeight:700,width:"90%"}}>기존 스크립트(0 줄)</Box>
                <Box sx={{fontSize:"14px", fontWeight:700,width:"100%"}}>수집 SRT(0 줄)</Box> */}
                <Box sx={{fontSize:"36px", paddingTop:"8px", color:"#60ad50", fontWeight:700,width:"100%"}}><b style={{color:"#000"}}>ANSWER : </b>[{data.answer}]</Box>
              </Box>
              

            </Box>

            <Box sx={{height:"100%", overflow:"auto", background: "linear-gradient(to right, #e6e6e6 30%, #deebfa 70%)"}}>
          <Box display="flex" justifyContent="center" >

          <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
            <Box sx={{width:"450px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>EN</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Activity</Box>
                      <Box><textarea value={data.activity_en} onChange={(e) => {setData({ ...data, activity_en: e.target.value });}} style={{width:"430px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question_a</Box>
                      <Box><textarea value={data.question_a_en} onChange={(e) => {setData({ ...data, question_a_en: e.target.value });}} style={{width:"430px",minHeight:"120px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question_b</Box>
                      <Box><textarea value={data.question_b_en} onChange={(e) => {setData({ ...data, question_b_en: e.target.value });}} style={{width:"430px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px"}}>
                <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Options</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "A" ? "red" : "#000")}}>A</Box>
                    <Box><textarea value={data.choice_en_1} onChange={(e) => {setData({ ...data, choice_en_1: e.target.value });}} style={{width:"392px",minHeight:"60px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "B" ? "red" : "#000")}}>B</Box>
                  <Box><textarea value={data.choice_en_2} onChange={(e) => {setData({ ...data, choice_en_2: e.target.value });}} style={{width:"392px",minHeight:"60px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "C" ? "red" : "#000")}}>C</Box>
                  <Box><textarea value={data.choice_en_3} onChange={(e) => {setData({ ...data, choice_en_3: e.target.value });}} style={{width:"392px",minHeight:"60px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "D" ? "red" : "#000")}}>D</Box>
                  <Box><textarea value={data.choice_en_4} onChange={(e) => {setData({ ...data, choice_en_4: e.target.value });}} style={{width:"392px",minHeight:"60px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
            </Paper>

            <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
              <Box sx={{width:"450px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>VI</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Activity</Box>
                      <Box><textarea spellCheck="false" value={data.activity_vi} onChange={(e) => {setData({ ...data, activity_vi: e.target.value });}} style={{width:"430px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question_a</Box>
                      <Box><textarea spellCheck="false" value={data.question_a_vi} onChange={(e) => {setData({ ...data, question_a_vi: e.target.value });}} style={{width:"430px",minHeight:"120px", fontSize:"18px",padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question_b</Box>
                      <Box><textarea spellCheck="false" value={data.question_b_vi} onChange={(e) => {setData({ ...data, question_b_vi: e.target.value });}} style={{width:"430px",minHeight:"40px", fontSize:"18px",padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px"}}>
                <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Options</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                    <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "A" ? "red" : "#000")}}>A</Box>
                    <Box><textarea spellCheck="false" value={data.choice_vi_1} onChange={(e) => {setData({ ...data, choice_vi_1: e.target.value });}} style={{width:"392px",minHeight:"60px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                    <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "B" ? "red" : "#000")}}>B</Box>
                    <Box><textarea spellCheck="false" value={data.choice_vi_2} onChange={(e) => {setData({ ...data, choice_vi_2: e.target.value });}} style={{width:"392px",minHeight:"60px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "C" ? "red" : "#000")}}>C</Box>
                  <Box><textarea spellCheck="false" value={data.choice_vi_3} onChange={(e) => {setData({ ...data, choice_vi_3: e.target.value });}} style={{width:"392px",minHeight:"60px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "D" ? "red" : "#000")}}>D</Box>
                  <Box><textarea spellCheck="false" value={data.choice_vi_4} onChange={(e) => {setData({ ...data, choice_vi_4: e.target.value });}} style={{width:"392px",minHeight:"60px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                  </Box>
                </Box>
              </Box>
            </Paper>

            <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
              <Box sx={{width:"450px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Activity</Box>
                      <Box><textarea value={data.activity_ko} onChange={(e) => {setData({ ...data, activity_ko: e.target.value });}} style={{width:"430px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question_a</Box>
                      <Box><textarea value={data.question_a_ko} onChange={(e) => {setData({ ...data, question_a_ko: e.target.value });}} style={{width:"430px",minHeight:"120px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question_b</Box>
                      <Box><textarea value={data.question_b_ko} onChange={(e) => {setData({ ...data, question_b_ko: e.target.value });}} style={{width:"430px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px"}}>
                <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Options</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "A" ? "red" : "#000")}}>A</Box>
                  <Box><textarea value={data.choice_ko_1} onChange={(e) => {setData({ ...data, choice_ko_1: e.target.value });}} style={{width:"392px",minHeight:"60px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "B" ? "red" : "#000")}}>B</Box>
                  <Box><textarea value={data.choice_ko_2} onChange={(e) => {setData({ ...data, choice_ko_2: e.target.value });}} style={{width:"392px",minHeight:"60px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "C" ? "red" : "#000")}}>C</Box>
                  <Box><textarea value={data.choice_ko_3} onChange={(e) => {setData({ ...data, choice_ko_3: e.target.value });}} style={{width:"392px",minHeight:"60px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "D" ? "red" : "#000")}}>D</Box>
                  <Box><textarea value={data.choice_ko_4} onChange={(e) => {setData({ ...data, choice_ko_4: e.target.value });}} style={{width:"392px",minHeight:"60px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
            </Paper>

            
          </Box>
        </Box>

            {/* <Box display="flex" justifyContent="center" sx={{textAlign:"center", marginTop:"2px", background: "linear-gradient(to right, #e6e6e6 30%, #8bb5e4 70%)"}}>
              <Box sx={{fontSize:"14px", fontWeight:700,width:"90%"}}>기존 스크립트({con_script.length} 줄)</Box>
              <Box sx={{fontSize:"14px", fontWeight:700,width:"100%"}}>수집 SRT({nvSttSrt.length} 줄)</Box>
            </Box> */}

            
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
            onClick={() => {
              props.setDialogOpen(false);
            }}
          >
            CANCEL
          </Button>
          <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
            onClick={() => {
              saveHlswData();
            }}
          >
            SAVE
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default HlswDetailDialog;
